import { useEffect, useState } from 'react';
import { TokenOrProvider } from 'stream-chat';
import { useMutation } from '@apollo/client';
import { AddUserToWorkOrderCommentsDocument } from 'graphql-query-contracts';
import { useCreateChatClient } from 'stream-chat-react';
import { config } from 'client-config';

type UseStreamChatInitProps = {
  user: { id: string; name?: string };
  channelId: string;
  tokenOrProvider: TokenOrProvider;
};

export function useGetStreamChatInit({
  user,
  channelId,
  tokenOrProvider,
}: UseStreamChatInitProps) {
  const [addUserToWorkOrderCommentsMutation] = useMutation(
    AddUserToWorkOrderCommentsDocument
  );

  const [channel, setChannel] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const chatClient = useCreateChatClient({
    apiKey: config.getStream.apiKey,
    userData: { id: user.id, name: user.name },
    tokenOrProvider,
  });

  useEffect(() => {
    async function init() {
      try {
        await addUserToWorkOrderCommentsMutation({
          variables: { serviceRequestId: channelId },
        });

        if (!chatClient) return;

        const channel = chatClient.channel('service_request', channelId);

        await channel.watch();

        setChannel(channel);
        setLoading(false);
        setError(null);
      } catch (err: any) {
        console.error(err);
        setError('Failed to connect to chat.');
        setLoading(false);
      }
    }

    init();
  }, [channelId, chatClient, addUserToWorkOrderCommentsMutation]);

  return { chatClient, channel, loading, error };
}
